/**
 * Index of the first label that starts with `query` (case-insensitive).
 * If none do, jumps to the first label that sorts at or after the query so
 * the list lands on the relevant alphabetical section instead of filtering.
 */
export function findPrefixJumpIndex(labels: readonly string[], query: string): number {
  if (labels.length === 0) return 0;

  const q = query.trim().toLowerCase();
  if (!q) return 0;

  const prefixIdx = labels.findIndex((label) => label.toLowerCase().startsWith(q));
  if (prefixIdx >= 0) return prefixIdx;

  const nextIdx = labels.findIndex((label) => label.toLowerCase().localeCompare(q) >= 0);
  return nextIdx >= 0 ? nextIdx : labels.length - 1;
}
